import {
	configureDialog,
	confirmDeletionDialog,
	confirmDialog,
	informDialog,
} from "./dialogs/dialogs.js";
import { widget, Widget } from "@foretagsplatsen/widgetjs";

const extensions = {
	inform: (...rest) => informDialog(...rest).show(),
	confirm: (...rest) => confirmDialog(...rest).show(),
	confirmDeletion: (...rest) => {
		confirmDeletionDialog(...rest).show();
	},
	configure: (...rest) => configureDialog(...rest).show(),
};

// Extend the klassified widget class:
widget.extend((that, my) => {
	for (const extensionName in extensions) {
		const func = extensions[extensionName];
		// Extend klassified widget:
		my[extensionName] = func;
	}
});

// Extend ES6 Widget:
for (const extensionName in extensions) {
	const func = extensions[extensionName];
	Widget.prototype[`_${extensionName}`] = func;
}

/**
 * Any object that `widgetjs` can render.
 *
 * @typedef {(number | string | Function | widget)} Renderable
 */

/**
 * Function returning a Renderable.
 *
 * @typedef {function(): Renderable} Renderer
 */
